import { getEnumStringValue, SocialMediaLink_ProviderMap } from 'js/utils/enum-string-maps';

import Icon from 'components/icon/Icon';
import Link from 'components/link/Link';

import { ISocialMediaLink } from 'source/NFR.types';

const SocialMediaLink: React.FC<ISocialMediaLink> = ({ provider, text, url }) =>
  url && (
    <Link className="social-media-link-list--button" title={text} url={url}>
      <Icon name={getEnumStringValue(SocialMediaLink_ProviderMap, provider) || ''} fill />
      <span>{text}</span>
    </Link>
  );

SocialMediaLink.displayName = 'SocialMediaLink';

export default SocialMediaLink;
